"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toColor = exports.color = void 0;
// Some colors taken from: https://flatuicolors.com/palette/nl
exports.color = [
    '#FFC312',
    '#F79F1F',
    '#EE5A24',
    '#EA2027',
    '#C4E538',
    '#A3CB38',
    '#009432',
    '#006266',
    '#12CBC4',
    '#1289A7',
    '#0652DD',
    '#1B1464',
    '#9980FA',
    '#ED4C67',
    '#B53471',
    '#833471',
    '#6F1E51',
    '#e27d60',
    '#85dcbb',
    '#e8a87c',
    '#c38d9e',
    '#41b3a3',
    '#242582',
    '#553d67',
    '#f64c72',
    '#99738e',
    '#2f2fa2',
    '#05386b',
    '#fc4445',
    '#3feee6',
    '#55bcc9',
    '#8ee4af',
    '#5cdb95',
    '#907163',
    '#379683',
    '#84ceeb',
    '#5ab9ea',
    '#8860d0',
    '#75b5d8',
    '#a64ac9',
    '#fccd04',
    '#17e9e0',
    '#61892f',
    '#86c232',
    '#222629',
    '#474b4f',
    '#6b6e70',
    '#eadb02',
    '#46344e',
    '#5a5560',
    '#fa72a1',
    '#e64398',
    '#f78888',
    '#1FB6FF',
    '#13CE66',
    '#FF4949',
    '#FFC82C',
    '#76266C',
    '#8C2E5E',
    '#5B2971',
    '#9B344E',
    '#4D2B73',
    '#AA4139',
    '#432F75',
    '#AA5D38',
    '#702D0C',
    '#3C1200',
    '#353377',
    '#FE8C00',
    '#FE7301',
    '#FE4301',
    '#FE0100',
    '#E5013B',
    '#CC0174',
    '#A0048C',
    '#560DAB',
    '#252AAC',
    '#0A6BA1',
    '#09A471',
    '#9DED05',
];
const hash_1 = require("thingies/lib/hash");
const toColor = (str) => exports.color[(0, hash_1.hash)(str) % exports.color.length];
exports.toColor = toColor;
//# sourceMappingURL=color.js.map